module.exports = __webpack_public_path__ + "static/media/podcast_banner.79b1b2a9.png";